import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import ValueTransition from '@/components/common/ValueTransition';
import VaultV2SummaryRow from './VaultV2SummaryRow';
interface VaultV2SummaryEarningsRowProps {
  label: string;
  initial: string;
  initialTooltip?: string;
  final?: string;
  finalTooltip?: string;
  showFinalValue: boolean;
  isLoading: boolean;
}
const VaultV2SummaryEarningsRow = t0 => {
  const $ = _c(19);
  const {
    label,
    initial,
    initialTooltip,
    final,
    finalTooltip,
    showFinalValue,
    isLoading
  } = t0;
  const t1 = showFinalValue ? "text-muted-foreground" : "text-foreground";
  let t2;
  if ($[0] !== initial || $[1] !== initialTooltip || $[2] !== t1) {
    t2 = {
      value: initial,
      colorClass: t1,
      tooltip: initialTooltip
    };
    $[0] = initial;
    $[1] = initialTooltip;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== final || $[5] !== finalTooltip) {
    t3 = {
      value: final,
      colorClass: "text-foreground",
      tooltip: finalTooltip
    };
    $[4] = final;
    $[5] = finalTooltip;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isLoading) {
    t4 = {
      isLoading
    };
    $[7] = isLoading;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== showFinalValue) {
    t5 = {
      showFinalValue
    };
    $[9] = showFinalValue;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <ValueTransition initial={t2} final={t3} loading={t4} config={t5} />;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== label || $[17] !== t6) {
    t7 = <VaultV2SummaryRow label={label}>{t6}</VaultV2SummaryRow>;
    $[16] = label;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export default memo(VaultV2SummaryEarningsRow);